import { render, staticRenderFns } from "./Spreadsheet.vue?vue&type=template&id=fdc35d7e&scoped=true"
import script from "./Spreadsheet.vue?vue&type=script&lang=js"
export * from "./Spreadsheet.vue?vue&type=script&lang=js"
import style0 from "./Spreadsheet.vue?vue&type=style&index=0&id=fdc35d7e&prod&lang=less&scoped=true"
import style1 from "./Spreadsheet.vue?vue&type=style&index=1&id=fdc35d7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc35d7e",
  null
  
)

export default component.exports